import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  errorMessage: "",
  successMessage: "",
  showSaveModal: false,
};

export const modalSlice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    /**
     * @description Reducer updates the states of success modal and shows the success modal with message
     */
    setShowSuccessModal(state, action) {
      state.successMessage = action.payload.message;
    },
    /**
     * @description Reducer updates the states of error modal and hides the error modal when user clicked on the page
     */
    onHideSuccessModal(state) {
      state.successMessage = "";
    },
    /**
     * @description Reducer updates the states of error modal and shows the error modal with message
     */
    setShowErrorModal(state, action) {
      state.errorMessage = action.payload.message;
    },
    /**
     * @description Reducer updates the states of success modal and hides the success modal when user clicked on the page
     */
    onHideErrorModal(state) {
      state.errorMessage = "";
    },
    setShowSaveModal(state) {
      state.showSaveModal = true;
    },
    onHideSaveModal(state) {
      state.showSaveModal = false;
    },
  },
});

export const {
  onHideErrorModal,
  onHideSuccessModal,
  setShowErrorModal,
  setShowSuccessModal,
  setShowSaveModal,
  onHideSaveModal,
} = modalSlice.actions;

export default modalSlice.reducer;
